import moment from "moment-timezone";
import { useEffect, useRef, useState } from "react";
import ChartComponent from "react-chartjs-2";
import usePalette from "../../hooks/usePalette";
import useSrlHelper from "../../hooks/useSrlHelper";

const UserMonthlyChart = ({ datasets, chartHeight }) => {
  const [chartData, setChartData] = useState();
  const [chartOptions, setChartOptions] = useState();
  const chartRef = useRef(null);
  const palette = usePalette();
  const { isSrl } = useSrlHelper();

  const colors = [
    {
      backgroundColor: palette.primary,
      borderColor: palette.primary,
      fontColor: palette.primary,
    },
    {
      backgroundColor: isSrl() ? "rgb(255, 128, 0)" : palette["danger"],
      borderColor: isSrl() ? "rgb(255, 128, 0)" : palette["danger"],
      fontColor: isSrl() ? "rgb(255, 128, 0)" : palette["danger"],
    },
  ];

  useEffect(() => {
    if (datasets && Array.isArray(datasets) && datasets.length > 0) {
      var chartOptions = {
        maintainAspectRatio: false,
        responsive: true,
        // redraw: true,
        legend: { labels: { fontColor: palette["gray-700"] } },
        scales: {
          xAxes: [
            {
              type: "time",
              gridLines: {
                display: false,
                color: palette["gray-400"],
              },
              time: {
                unit: "month",
                minUnit: "month",
                round: "month",
                tooltipFormat: "MMM YYYY",
                // displayFormats: {
                //   day: "MMM",
                //   //hour: "ha",
                // },
              },
              title: {
                display: true,
                text: "Date",
              },
              ticks: {
                display: true,
                autoSkip: false, // Skip ticks to avoid overlapping
                // autoSkipPadding: 10,
                min: moment().subtract(1, "years"),
                max: moment().add(1, "month"),
                // padding: 5,
                // maxRotation: 30,
                major: {
                  enabled: true,
                  display: true,
                  fontColor: palette["gray-700"],
                  // fontStyle: "bold",
                },
                minor: {
                  display: true,
                  fontColor: palette["gray-700"],
                },
              },
            },
          ],
          yAxes: [],
        },
      };

      var chartData = {
        datasets: [],
      };

      datasets.forEach((dataset, datasetIndex) => {
        if (
          dataset.data &&
          Array.isArray(dataset.data) &&
          dataset.data.length > 0
        ) {
          chartData.datasets.push({
            yAxisID: datasetIndex,
            type: dataset.type ?? "line",
            label: dataset.label ?? "label",
            data: dataset.data,
            lineTension: dataset.lineTension ?? 0,
            backgroundColor:
              colors[datasetIndex % colors.length].backgroundColor,
            borderWidth: 3,
            borderColor: colors[datasetIndex % colors.length].backgroundColor,
            pointRadius: dataset.pointRadius ?? 3,
            pointStyle: "rect",
            fill: false,
          });

          const yValues = dataset.data.map(
            (pointDataValue) => pointDataValue.y
          );
          const minY = Math.min(...yValues);
          const maxY = Math.max(...yValues);
          const suggestedMin = minY > 0 ? 0 : minY;
          const suggestedMax = maxY < 0 ? 0 : maxY;

          chartOptions.scales.yAxes.push({
            id: datasetIndex,
            type: "linear",
            position:
              dataset.position ?? datasetIndex % 2 === 0 ? "left" : "right",
            ticks: {
              suggestedMin: suggestedMin,
              suggestedMax: suggestedMax,
              fontColor: palette["gray-700"],
              autoSkip: true,
              // padding: 2,
              autoSkipPadding: 30,
              stepSize: Math.round(suggestedMax / 100) * 10,
              callback: function (value, index, values) {
                return (
                  (value.toLocaleString && value.toLocaleString()) ??
                  (value.toString && value.toString()) ??
                  ""
                );
              },
            },
            gridLines: {
              display: false,
              color: palette["gray-100"],
            },
          });
        }
      });

      if (chartData.datasets.length > 0) {
        setChartOptions(chartOptions);
        setChartData(chartData);
      }
    }
  }, [palette, datasets]);

  return (
    <>
      {chartOptions && chartData ? (
        <ChartComponent
          ref={chartRef}
          data={chartData}
          options={chartOptions}
          type={"line"}
          // redraw={true}
          height={chartHeight ?? 320}
          // responsive={true}
        />
      ) : (
        <div className="d-flex justify-content-center">No Data</div>
      )}
    </>
  );
};

export default UserMonthlyChart;
